import React from 'react';
import {connect} from 'react-redux';
import {RouteProps} from 'react-router';
import {Redirect, Route, RouteComponentProps} from 'react-router-dom';
import {PublicRoutes} from 'routes';
import {ApplicationState} from 'store/rootReducer';
import {UserRoles} from 'utils/AuthRoute';
interface Props {
  requiredRoles?: UserRoles[];
  exact?: boolean;
}

interface DispatchProps {
  isAuthed?: boolean;
  location?: RouteProps['location'];
  isAdmin: boolean;
  isStaff: boolean;
}

type NoAuthRouteProps = Props & DispatchProps;

const NoAuthRoute = ({
  exact = false,
  isAuthed,
  requiredRoles,
  location,
  isAdmin,
  isStaff,
}: NoAuthRouteProps): JSX.Element => {
  const userRole = isAdmin ? 'admin' : isStaff ? 'staff' : 'nonAdmin';
  const userHasRequiredRole = requiredRoles?.includes(userRole);
  const isUnauthorized = isAuthed && !userHasRequiredRole;
  const renderPageNotFound = isAuthed;
  return (
    <Route
      exact={exact}
      render={(props: RouteComponentProps) => {
        if (renderPageNotFound)
          return (
            <Redirect
              to={{
                pathname: PublicRoutes.notFound,
              }}
            />
          );

        if (isUnauthorized)
          return (
            <Redirect
              to={{
                pathname: PublicRoutes.unauthorized,
              }}
            />
          );

        if (!isAuthed)
          return (
            <Redirect
              to={{
                pathname: PublicRoutes.login,
                state: {
                  requestedPath: location?.pathname,
                },
              }}
            />
          );
      }}
    />
  );
};

export default connect((state: ApplicationState) => ({
  isAuthed: state.getIn(['authentication', 'data', 'is_authenticated']),
  isStaff: state.getIn(['authentication', 'data', 'user', 'is_staff']),
  isAdmin: state.getIn(['authentication', 'data', 'user', 'is_superuser']),
}))(NoAuthRoute);
